import { render, staticRenderFns } from "./PopupBar.vue?vue&type=template&id=bf79ea66&"
import script from "./PopupBar.vue?vue&type=script&lang=js&"
export * from "./PopupBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports